import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/shared/shared.module';
import { OrderStatusInfoComponent } from '../../components/order-submitted/order-status-info/order-status-info.component';
import { OrderSubmittedItemCardComponent } from '../../components/order-submitted/order-submitted-item-card/order-submitted-item-card.component';
import { OrderSubmittedRoutingModule } from './order-submitted-routing.module';
import { OrderSubmittedPage } from './order-submitted.page';
import { SubmittedOrderInfoCardComponent } from '../../components/order-submitted/submitted-order-info-card/submitted-order-info-card.component';
import { DealsPageModule } from '@app/deals/deals.module';
import { TranslateModule } from '@ngx-translate/core';
import { SortProductModalComponent } from '@order/components/sort-product-modal/sort-product-modal.component';
import { ShipToModalComponent } from '@order/components/ship-to-modal/ship-to-modal.component';
import { RecoveryOrderModalComponent } from '@order/components/recovery-order-modal/recovery-order-modal.component';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  declarations: [
    OrderSubmittedPage,
    OrderSubmittedItemCardComponent,
    SubmittedOrderInfoCardComponent,
    OrderStatusInfoComponent,
    SortProductModalComponent,
    ShipToModalComponent,
    RecoveryOrderModalComponent,
  ],
  imports: [
    CommonModule,
    OrderSubmittedRoutingModule,
    FormsModule,
    IonicModule,
    SharedModule,
    MatExpansionModule,
    DealsPageModule,
    TranslateModule,
    NgxPaginationModule,
  ],
})
export class OrderSubmittedPageModule {}
